<!-- <polyline points="25,5 45,25 25,45 5,25" pointer-events="none"/> -->

<!-- <g pointer-events="none" transform="scale(0.7)" transform-origin="25 25"> -->

<!-- 
   translate(10 10) ist geschätzt und sieht optisch brauchbar aus.
   transform-origin="25 25" wäre besser, wird aber von Word und Inkscape nicht unterstützt
-->

<g pointer-events="none" transform="scale(0.7) translate(10 10)">    
    <path
       style="display:inline;fill:#ffffff;fill-opacity:1;stroke:#8b8b8b;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       d="m 21.719515,27.580337 c -2.69152,1.65987 -5.681547,7.411817 -5.171313,11.376888 0.510234,3.965072 3.211737,7.240154 6.808896,7.584593 3.597159,0.344439 8.587093,-2.546016 9.394552,-5.602256 0.807459,-3.05624 -3.275914,-4.693538 -3.964674,-6.981273 -0.68876,-2.287735 1.115112,-5.013427 -0.430942,-6.291764 -1.546054,-1.278337 -3.944999,-1.746058 -6.636519,-0.08619 z"
       id="path3300" /><path
       style="display:inline;fill:#ff0f00;fill-opacity:1;stroke:#9b0900;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       d="m 23.615663,6.3779528 c -5.1463,0.3773188 -8.004538,5.6312082 -11.2907,7.8431582 -3.2861621,2.21195 -8.6847578,0.946962 -8.3602896,5.516067 C 4.2891416,24.306283 11.34342,29.788843 27.063205,29.390296 42.78299,28.991749 42.158661,26.686914 42.404767,22.495212 42.650873,18.30351 41.458341,17.008865 38.440094,13.876357 35.421847,10.743849 28.761963,6.000634 23.615663,6.3779528 Z"
       id="path3235" /><ellipse
       style="fill:#ffffff;fill-opacity:1;stroke:#9b0900;stroke-width:0.958992;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path3375"
       cx="15.604259"
       cy="18.963541"
       rx="2.2829533"
       ry="1.983459" /><ellipse
       style="display:inline;fill:#ffffff;fill-opacity:1;stroke:#9b0900;stroke-width:1.03759;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path3375-8"
       cx="28.796282"
       cy="13.895349"
       rx="2.45696"
       ry="2.1574657" /><ellipse
       style="display:inline;fill:#ffffff;fill-opacity:1;stroke:#9b0900;stroke-width:1.03906;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path3375-2"
       cx="23.402693"
       cy="24.164497"
       rx="2.2429206"
       ry="2.3700378" /><ellipse
       style="display:inline;fill:#ffffff;fill-opacity:1;stroke:#9b0900;stroke-width:1.04282;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path3375-83"
       cx="33.214756"
       cy="23.463636"
       rx="2.4848161"
       ry="2.1548493" />
</g>